// Vendor imports
const _ = require('lodash')
const React = require('react')

/**
 * This is a constant so that it does not change between renders
 * @type {JSX.Element}
 * @readonly
 */

function IntoLandingFeedItemCard(props) {
  const { href, item } = props
  const article = _.get(item, 'article')
  const meta = _.get(item, 'meta')
  const [height, setHeight] = React.useState(0)
  const ref = React.useRef()

  // Workaround for aspect-ratio
  React.useEffect(() => {
    function onResize() {
      setHeight(ref.current.clientWidth)
    }

    onResize()
    window.addEventListener('resize', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [ref])

  const mp4Url = _.get(meta, 'media[0].mp4_url')
  // Render
  return (
    <a
      href={href}
      style={{ backgroundColor: '#2C2C2E' }}
      className="grid-item relative z-10 rounded overflow-hidden"
    >
      {mp4Url ? (
        <video
          ref={ref}
          src={mp4Url}
          style={{ height: `${height}px` }}
          poster={article.thumbnail}
          className="block w-full h-full object-cover aspect-square transition-all hover:scale-105"
          autoPlay
          muted
          loop
          playsInline
        />
      ) : (
        <img
          ref={ref}
          style={{ height: `${height}px` }}
          src={article.thumbnail}
          className="block w-full h-full object-cover aspect-square transition-all hover:scale-105"
          alt={article.title}
          loading="lazy"
        />
      )}
    </a>
  )
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')
  const ArticleModelRecord = require('client-v2/common/models/article/record')

  IntoLandingFeedItemCard.propTypes = {
    // Values
    className: PropTypes.string,
    href: PropTypes.string,
    item: PropTypes.shape(ArticleModelRecord.propTypes),
    // Callbacks
    onClick: PropTypes.func,
    onFollowClick: PropTypes.func
  }
}

module.exports = IntoLandingFeedItemCard
